import React, {useState} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const TestimonialItem = ({title, text, translations}) => {
  const [showMore, setShowMore] = useState(false);
  const toggleMore = () => setShowMore((prev) => !prev);

  const {readMore, readLess} = translations;

  const isTextTruncated = text.length > 219;
  const textClasses = classnames('mt-1 mb-5', {
    'max-lines-3': !showMore && isTextTruncated
  });

  return (
    <div style={{minHeight: '200px'}}>
      <div className="font-bold text-lead">{title}</div>
      <div className={textClasses}
        dangerouslySetInnerHTML={{__html: text}}></div>
      {isTextTruncated &&
        <span className='text-primary d-flex justify-content-end mb-3 cursor-pointer'
          onClick={toggleMore}>
          {showMore ? readLess : readMore}
        </span>}
    </div>
  );
};

TestimonialItem.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  translations: PropTypes.shape({
    readMore: PropTypes.string.isRequired,
    readLess: PropTypes.string.isRequired
  })
};

export default TestimonialItem;